import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import SixSectionStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';
import { keepAlive } from 'mobx-utils';
const styles = require('./index.less');

/**
 *
 * @param store {}
 * @returns {JSX.Element}
 * @constructor
 */
const SixSection = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.sixSectionRoot)} style={{ height: window.innerHeight + 'px' }}>
      <div className={styles.hudBox}>
        <div className={styles.hudLeft} />
        <div className={styles.hudRight} />
      </div>
      <div className={styles.mapSwiper}>
        <BaseSwiper store={store.mapSwiper}>
          {store.list?.map((item, index) => {
            return (
              <div className={cx('mapItem', styles.mapItem)} key={index}>
                <div className={cx('contentText')}>
                  <div className={styles.title}>
                    <div>
                      <div className={styles.tips}>
                        {index + 1}
                        /
                        {store.list?.length}
                        <span className="square" />
                      </div>
                    </div>
                    <div className={styles.titleTail}>
                      <div>0{index + 1}</div>
                      <div>{item.name}</div>
                    </div>
                  </div>

                  <div className={styles.textBox}>
                    <div className={styles.information}>
                      <div className={styles.progressLine}>
                        <div className={cx('progress')} />
                      </div>
                    </div>
                    <div className={styles.info}>
                      <span>{item?.info}</span>
                    </div>
                    {/* <div className={styles.info}>{item?.info.map?.(txt => <span key={txt}>{txt}</span>)}</div> */}
                  </div>
                </div>
                <div className={styles.mapImg} style={{ backgroundImage: `url(${item.characteristicImgs})` }} />
              </div>
            );
          })}
        </BaseSwiper>
        <Link className={cx('swiper-prev', 'swiper-btn')} onClick={() => store.mapSwiper.goPrev()} />
        <Link className={cx('swiper-next', 'swiper-btn')} onClick={() => store.mapSwiper.goNext()} />
        <div className={styles.mechaTabSwiper} onClick={store.onMechaPaginationClick}>
          <BaseSwiper store={store.mechaTabSwiper}>
            {store.list?.map((item, index) => {
              return (
                <div className={cx('mechaTab')} key={index}>
                  <Link className="clickMo" data-mecha-code={index} />
                  <div className="mechaNormal" style={{ backgroundImage: `url(${item.mapIcon})` }} />
                  {store.mapSwiper.activeIndex === index && <div className="mechaNormal_decorate" />}
                  {store.mapSwiper.activeIndex === index && <div className={cx('swiperLine2')} />}
                </div>
              );
            })}
          </BaseSwiper>
        </div>
        <div className={styles.pagination}>
          {store.list?.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => store.onClickChangeSwiper(index)}
                className={cx('slick', store.isActive && store.mapSwiper.activeIndex === index && 'active')}
              />
            );
          })}
          <div className={styles.count}>
            {store.mapSwiper.activeIndex + 1}/{store.list?.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(SixSection, SixSectionStore);
